import Web3 from "web3";
import sessionData from "../sessionData";
import { ERROR_TYPE_TRANSACTION } from "./constants";
import { getWalletAddress } from "./cryptoWallet";

export function makeAddr(addr) {
    return addr ? `${addr.toUpperCase().substring(0, 8)}...${addr.toUpperCase().substring(addr.length - 3, addr.length)}` : undefined
}

export const validateEmail = (email) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

export const apiImage = (data, onOk, onError) => {
    rawCall("", data, onOk, onError)
}

const rawCall = async (url, data, onOk, onError) => {
    if (!url) console.log("API must be not NULL")
    // console.log(`calling api ${  url}`)
    // console.log(data)
    const response = await fetch(url, {
        method: 'POST',
        headers: {
        },
        body: JSON.stringify(data)
    })

    const ret = await response.text()
    if (!response.ok) {
        onError(ret)
    }
    onOk(ret)
}

const apiCall = (url, data, onOk, onError) => {
    if (!url) console.log("API must be not NULL")
    // console.log(`calling api ${  url}`)
    // console.log(data)
    fetch(url, {
        method: 'POST',
        headers: {
        },
        body: JSON.stringify(data)
    })
        .then(response => response.json())
        .then(responseJson => {
            // console.log(responseJson)
            const content = responseJson

            if (content.code === 200) {
                if (onOk) onOk(content)

            } else if (onError) onError(content.message)

        })
        .catch(
            error => {
                console.log(JSON.stringify(error))
                if (onError) onError(error)
            }
        );
}

function addDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
}

export function getURLParameter1(name) {
    return decodeURIComponent((new RegExp(`[?|&]${name}=([^&;]+?)(&|#|;|$)`).exec(window.location.search)
        || [null, ''])[1].replace(/\+/g, '%20')) || null;
}

export function getURLParameter(name) {
    const urlString = window.location
    const url = new URL(urlString);
    return url.searchParams.get(name);
}

// export const isMobileBrowser = () => {
//     let check = false;
//     (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
//     return check;
// };

export function getOwnerLink(owner) {
    const uri = (`id=${  owner.id  }&name=${  encodeURIComponent(owner.name)  }&address=${  owner.ethAddr}`)
    return uri;
}

function fallbackCopyTextToClipboard(text) {
    const textArea = document.createElement("textarea");
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
        const successful = document.execCommand('copy');
        const msg = successful ? 'successful' : 'unsuccessful';
        // console.log(`Fallback: Copying text command was ${  msg}`);
    } catch (err) {
        console.error('Fallback: Oops, unable to copy', err);
    }
    document.body.removeChild(textArea);
}

export function copyTextToClipboard(text) {
    if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(text);
        return;
    }
    navigator.clipboard.writeText(text).then(() => {
        // console.log('Async: Copying to clipboard was successful!');
    }, (err) => {
        console.error('Async: Could not copy text: ', err);
    });
}

function parseWeb3Error(error){
    if (!error) return "Unkown Error!"
    const MESSAGE = `"message": "`
    const index = error.indexOf(MESSAGE)
    const endIndex = error.indexOf(`",`)
    // eslint-disable-next-line eqeqeq
    if (index == -1 || endIndex == -1) return "Unkown Error!"
    return error.substring(index + MESSAGE.length , endIndex) 
}

export const handleResult = async (contractMethod, enqueueSnackbar, onComplete = null, onError = null, priceValue = null) => {

    const param = { from: getWalletAddress() }
    if (priceValue) param.value = priceValue
    
    const gasLimit = await contractMethod.estimateGas(param)
        .catch(
            (error) => {
                enqueueSnackbar(parseWeb3Error(error.message), { variant: 'error', persist: true });
                if (onError) onError(error)
                return false;
            }
        )
    if (gasLimit) {
        console.log(`gasLimit ${gasLimit}`)
        if (priceValue) param.gas = gasLimit
        const result = contractMethod.send(param)
        
        if (!result) return
        result
            .on('transactionHash', (hash) => {
                enqueueSnackbar('Transaction is being processed. Please wait!', { variant: 'info', autoHideDuration: 5000 });
            })
            .on('receipt', () => {
                enqueueSnackbar('Your transaction is completed!', { variant: 'success', autoHideDuration: 5000 });
                if (onComplete) onComplete(result)
            })
            // .on('error', (error, receipt) => {
            //     let errorTitle = ""
            //     let errorContent = ""
            //     let errorType = 0
            //     if (receipt) {// error từ chain, lấy tx để debug
            //         errorTitle = "Transaction Error!"
            //         errorContent = receipt.transactionHash
            //         errorType = ERROR_TYPE_TRANSACTION
            //         enqueueSnackbar([errorTitle, errorContent, errorType], { variant: 'error', persist: true });
            //         if (onError) {
            //             onError(error)
            //             return false
            //         }
            //     } else if (error) {// error từ ví hoặc cái gì khác
            //         errorTitle = "There was an Error!"
            //         errorContent = error.message
            //         enqueueSnackbar(errorContent, { variant: 'error', persist: true });
            //         if (onError) {
            //             onError(error)
            //             return false
            //         }
            //     }
            //     // if (errorTitle && errorContent) enqueueSnackbar([errorTitle, errorContent, errorType], { variant: 'error', persist: true });
            
            // })
            .catch((error) => {
                enqueueSnackbar(error.message, { variant: 'error', persist: true });
                if (onError) {
                    onError(error)
                    return false
                }
            })
    }
}
/**
 * Checks if the given string is an address
 *
 * @method isAddress
 * @param {String} address the given HEX adress
 * @return {Boolean}
*/
// const isAddress = (address) => {
//     if (!/^(0x)?[0-9a-f]{40}$/i.test(address)) {
//         // check if it has the basic requirements of an address
//         return false;
//     } if (/^(0x)?[0-9a-f]{40}$/.test(address) || /^(0x)?[0-9A-F]{40}$/.test(address)) {
//         // If it's all small caps or all all caps, return true
//         return true;
//     } 
//         // Otherwise check each case
//         return isChecksumAddress(address);
// };

// /**rtg
//  * Checks if the given string is a checksummed address
//  *
//  * @method isChecksumAddress
//  * @param {String} address the given HEX adress
//  * @return {Boolean}
// */
// const isChecksumAddress = (address) => {
//     // Check each case
//     address = address.replace('0x','');
//     const addressHash = sha3(address.toLowerCase());
//     for (let i = 0; i < 40; i++ ) {
//         // the nth letter should be uppercase if the nth digit of casemap is 1
//         if ((parseInt(addressHash[i], 16) > 7 && address[i].toUpperCase() !== address[i]) || (parseInt(addressHash[i], 16) <= 7 && address[i].toLowerCase() !== address[i])) {
//             return false;
//         }
//     }
//     return true;
// };


